export const MANAGEFLAVOR = 'MANAGEFLAVOR'
export const MANAGEFLAVORTYPE = 'MANAGEFLAVORTYPE'
export const MANAGEINSTANCEREGION = 'MANAGEINSTANCEREGION'